module.exports = __webpack_public_path__ + "static/hero-top-1-sp-e9985b62304bba6e88669ccd165419e4.png";